export default "__VITE_PUBLIC_ASSET__827dad3b__"